import { Backdrop, Box, Button, Slide} from "@mui/material";
import { SnakeLoader } from "../../../../../../../core/loader/SnakeLoader";

export const Confirmation = ({ openModal, templateForm, proceedHandler }) => {
    const cd = templateForm.data;
    return (
        <Backdrop sx={{ pl: 25, zIndex: 3503, display: "flex", alignItems: "start", pt: "2rem"}} open={cd.submit.modal}>
            <Slide in={cd.submit.modal} direction="down">
                <Box display="flex" flexDirection="column" bgcolor="#fff" alignItems="center" borderRadius={3} width={350} p={4}>
                    <Box fontSize={16} color="text.primary">{ cd.submit.typeModal === "save" ? "Save your Website" : cd.submit.typeModal === "publish" ? "Publish your Website" : "Update your Website" 
                    // : cd.submit.status === "request" ? `Request to use 
                    //  as your website domain ` : "Unkown" 
                     }?</Box>
                    {/* <Box fontSize={16} color="text.primary">
                        {cd.submit.type.publish
                            ? "Publish your Website"
                            : (
                                <>
                                    Request to use
                                    <Typography component="span" sx={{ color: '#FE9900', fontFamily: 'Arial, sans-serif', fontWeight: 'bold' }}>
                                        {` ${cd.own_domain.value} `}
                                    </Typography>
                                    as your website domain
                                </>
                            )
                        }?
                    </Box> */}
                    <Box width="100%" pt={4}>
                        <Box width="100%" display="flex" gap="8px" mt="auto">
                            <Box onClick={() => openModal("cancel", 0)} component={Button} 
                                bgcolor="#E5F2EC" color="#009F4D" fontSize={14} fontWeight={600} border="1px solid #009F4D" width="50%" borderRadius="6px"
                                sx={{":hover": { color: "#009F4D", bgcolor: "#E5F2EC" }, }}
                            >
                                Cancel
                            </Box>
                            <Box component={Button} bgcolor="#009F4D" color="#fff" fontSize={14} fontWeight={600} width="50%" borderRadius="6px"
                                sx={{":hover": { color: "#fff", bgcolor: "#009F4D" },}}
                                onClick={()=> proceedHandler()}
                            >
                                {!cd.submit.confirmed ? "Yes" :
                                    <Box display="flex" alignItems="center">
                                        {cd.submit.typeModal === "save" ? "Saving" : cd.submit.typeModal === "publish" ? "Publishing" : "Updating"}
                                        <SnakeLoader size="5px" bg="#fff" distance="2.5px"/>
                                    </Box>
                                }
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Slide>
        </Backdrop>
    );
};